import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: false,
      refetchOnWindowFocus: false,
      retry: false,
      networkMode: 'offlineFirst',
    },
    mutations: {
      throwOnError: false,
      retry: false,
      networkMode: 'offlineFirst',
    },
  },
})
